<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Novo Contrato</b>
                        </h3>
                    </div>

                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-4" :class="{ 'has-error': showTextDangerUnidade }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerUnidade }">Unidade</label>
                                    <select-unidade
                                        :show-text-danger-unidade="showTextDangerUnidade"
                                        @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadeSelecionada(unidadeSelecionada);
                                            }
                                        "
                                        :nomeUnidade="dados.unidade.nome"
                                    ></select-unidade>
                                </div>
                            </div>
							<div class="col-md-2" :class="{ 'has-error': showTextDangerTipoPessoa }">
								<div class="form-group">
									<label :class="{ 'erro-validacao': showTextDangerTipoPessoa }">Tipo de pessoa</label>
									<select v-model="dados.tipo_pessoa" class="form-control">
										<option value="">Selecione</option>
										<option value="0">Física</option>
										<option value="1">Jurídica</option>
									</select>
								</div>
							</div>
                            <div class="col-md-2" :class="{ 'has-error': showTextDangerTipo }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerTipo }">Tipo de Contrato</label>
                                    <select v-model="dados.tipo" class="form-control">
                                        <option value="0">Solicitante</option>
                                        <option value="1">Prestador</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2" :class="{ 'has-error': showTextDangerDataInicial }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerDataInicial }">Data Inicial</label>
                                    <input v-model="dados.data_inicial" class="form-control" type="date" />
                                </div>
                            </div>
                            <div class="col-md-2" :class="{ 'has-error': showTextDangerDataFinal }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerDataFinal }">Data Final</label>
                                    <input v-model="dados.data_final" class="form-control" type="date" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" :class="{ 'has-error': showTextDangerLimiteGeral }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerLimiteGeral }">Limite Geral (R$)</label>
                                    <money class="form-control" v-model="dados.limite_geral" v-bind="money"></money>
                                </div>
                            </div>

                            <div class="col-md-3" :class="{ 'has-error': showTextDangerLimiteCancelamento }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerLimiteCancelamento }">Limite de Cancelamentos</label>
                                    <input v-model="dados.limite_cancelamento" class="form-control" type="number" />
                                </div>
                            </div>
                            <div class="col-md-3" :class="{ 'has-error': showTextDangerLimiteRegulacao }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerLimiteRegulacao }">Limite de Regulações</label>
                                    <input v-model="dados.limite_regulacao" class="form-control" type="number" />
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'has-error': showTextDangerSituacao }">
                                    <label :class="{ 'erro-validacao': showTextDangerSituacao }">Situação</label>
                                    <select v-model="dados.situacao" class="form-control">
                                        <option value="1">Ativo</option>
                                        <option value="0">Inativo</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import selectUnidade from "../../cadastros/unidades/selectUnidade";
import { Money } from "v-money";

export default {
    filters: {},
    data: () => ({
        atualizacao: false,

        showTextDangerDataInicial: false,
        showTextDangerDataFinal: false,
        showTextDangerSituacao: false,
		showTextDangerTipoPessoa: false,
        showTextDangerTipo: false,
        showTextDangerLimiteCancelamento: false,
        showTextDangerLimiteRegulacao: false,
        showTextDangerLimiteGeral: false,
        showTextDangerUnidade: false,

        money: {
            decimal: ",",
            thousands: ".",
            prefix: "R$ ",
            precision: 2,
            masked: false
        },
        dados: {
            data_inicial: "",
            data_final: "",
            situacao: 1,
			tipo_pessoa: "",
            tipo: 0,
            limite_cancelamento: 0,
            limite_regulacao: 0,
            limite_geral: 0,
            unidade_id: "",
            unidade: {
                nome: null
            }
        }
    }),
    mounted() {
        if (this.$route.params.contrato_id) {
            this.getById(this.$route.params.contrato_id);
            this.atualizacao = true;
        }
    },
    methods: {
        salvar() {
            if (this.validar()) {
                if (this.atualizacao) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/distribuicao/contratos/update/${this.dados.id}`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.$swal({
                                type: "success",

                                title: "Contrato atualizado com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.push("/distribuicao/controle-contratos/");
                        })
                        .catch(error => {
                            var erros = error.response.data.message + " ";
                            for (var erro of Object.values(error.response.data.errors)) {
                                erros += erro + " \n";
                            }
                            this.$swal({
                                type: "error",
                                title: "Houve uma falha!",
                                text: erros
                            });
                        });
                } else {
                    axios
                        .post(`${this.$store.state.serverURI}/api/distribuicao/contratos/create`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    type: "success",
                                    title: response.data.msg,
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                this.$router.push("/distribuicao/controle-contratos/");
                            } else {
                                this.$swal({
                                    type: "error",
                                    title: response.data.titulo_msg,
                                    text: response.data.msg,
                                    showConfirmButton: true
                                }).then(() => {
                                    this.$router.push("/distribuicao/controle-contratos/");
                                });
                            }
                        })
                        .catch(error => {
                            var erros = error.response.data.message + " ";
                            for (var erro of Object.values(error.response.data.errors)) {
                                erros += erro + " \n";
                            }
                            this.$swal({
                                type: "error",
                                title: "Houve uma falha!",
                                text: erros
                            });
                        });
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },

        getById(contratoId) {
            this.$store.commit("TOGGLE_LOADING");
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/contratos/getById/${contratoId}`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.dados = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        },

        setUnidadeSelecionada(unidadeSelecionada) {
            this.dados.unidade_id = unidadeSelecionada.id;
        },

        validar() {
            let validou = true;
			if (this.dados.tipo_pessoa != "0" && this.dados.tipo_pessoa != "1") {
				this.showTextDangerTipoPessoa = true;
				validou = false;
			}
            if (this.dados.data_inicial === "") {
                this.showTextDangerDataInicial = true;
                validou = false;
            }
            if (this.dados.data_final === "") {
                this.showTextDangerDataFinal = true;
                validou = false;
            }
            if (this.dados.situacao === "") {
                this.showTextDangerSituacao = true;
                validou = false;
            }
            if (this.dados.tipo === "") {
                this.showTextDangerTipo = true;
                validou = false;
            }
            if (this.dados.limite_cancelamento === "") {
                this.showTextDangerLimiteCancelamento = true;
                validou = false;
            }
            if (this.dados.limite_regulacao === "") {
                this.showTextDangerLimiteRegulacao = true;
                validou = false;
            }
            if (this.dados.limite_geral === "") {
                this.showTextDangerLimiteGeral = true;
                validou = false;
            }
            if (this.dados.unidade_id === "") {
                this.showTextDangerUnidade = true;
                validou = false;
            }

            return validou;
        }
    },
    watch: {},
    components: {
        selectUnidade,
        Money
    }
};
</script>
<style>
.erro-validacao {
    color: #d73925;
}
</style>



// WEBPACK FOOTER //
// form.vue?d55c5514